import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, AfterContentChecked, ChangeDetectorRef, ElementRef, ViewChildren, ViewChild, OnDestroy, Injector } from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';
import { QuestionControlService } from '../form/question-control.service';
import { BaseService } from '../../shared/services/base.service';
import { CompositeArrayObjectComponent } from './composite-array-object.component';
//import { DecoratorDirective } from '../../directive/decorator.directive';
import { DialogService } from '../dialog/dialog.service';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { AppService } from '../../shared/services/app.service';
import { AlertsService } from '../../services/alerts.service';
import { PopUpOverGridWithControlsComponent } from '../dynamic-Grid-with-control/pop-up-over-grid-with-controls/pop-up-over-grid-with-controls.component';
import { editableGridService } from '../dynamic-Grid-with-control/editableGrid.service';
import { SmartModalService } from '../../services/smart-modal.service';
import { UtilService } from '../../services/util.service';
import { AsideBarService } from '../../services/asideBar.service';
import { DialogModalSize } from '../dialog/dialog-ref';
import { ShowPdfComponent } from '../file-uploader/show-pdf/show-pdf.component';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import { PrintService } from '../../shared/services/print.service';
import { CommunicationService } from '../../services/communication.service';
import { distinctUntilChanged, finalize, tap } from 'rxjs/operators';
import { LoaderService } from '../../services/loader.service';
import { DataGridComponent } from '../data-grid/data-grid.component';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'dhs-composite-array',
    templateUrl: './composite-array.component.html',
    styleUrls: ['./composite-array.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: CompositeArrayComponent,
        multi: true,
    }],
    standalone: false
})
export class CompositeArrayComponent implements ControlValueAccessor, OnInit, OnDestroy {
    @ViewChild("appendHtml") appendHtml: ElementRef;
    @ViewChild("datagrid") datagrid: DataGridComponent
    //@Input() fieldGroup: any = [];
    @Input('value') _value: any;
    @Input() resource: string;
    @Input() id: any = false;
    @Input() arrayLimit: number;
    @Input() buttonText: string;
    @Input() buttonProps: any = { buttonClass: 'primary-btn' };
    @Input() decorator: any;
    // @Input() dirdecorator: string;
    @Input() current_action: string;
    @Input() populateField: string;
    @Input() config: any = {};
    @Input() question: any = {};
    btn = {
        "Add": [
            {
                "label": "Add",
                "icon": "fa fa-plus"
            }
        ],
        "Modify": [
            {
                "label": "Add",
                "icon": "fa fa-plus",
            }
        ]
    };
    @Input() bannerJson: any;
    @Input() minWidth: string;
    @Input() parentForm: FormGroup;
    @Input() dependentField: string = "";
    @Input() dependentFieldMap: any[] = [];
    @Input() replace_items: string = "";
    @Input() item_key: string = "";
    fieldGroupQues: any = [];
    formQcs: FormGroup;
    fields: any = [];
    @Input() items: Array<any> = [];
    propagateChange = (_: any) => { };
    fieldGroups: any = [];
    formBlocks: any = [];
    listBlocks: any = [];
    btnDisabled: boolean = false;
    activatedResource: string;
    //for flat form
    popupfields: any;
    objData: { formblocks: any; data: any; activatedResource: string; };
    showflatform: boolean = false;
    setUpdate: any = false;
    @Output() valueAdded: EventEmitter<any> = new EventEmitter();
    @Output() onRemoveItem: EventEmitter<any> = new EventEmitter();
    @Output() getData: EventEmitter<any> = new EventEmitter();//for outputting general configration
    hide_array_button: boolean = false;
    dependentVal: string = "";
    private dependentMapVals: { [populateField: string]: any } = {};
    private childForm: any;
    private childQuestions: any;
    showPage: boolean = true;
    form_config: any;
    selectedFiles: any = [];
    customButton: any;
    gridConfig: any;
    customCapability: any = [];
    private addRowBelowBusy: boolean = false;
    isCims: any = {};
    _currentData: any = {};
    storeItems: any;
    error_message: string = "Duplicate values not allowed.";
    isSubscriptionDoneForModify = false;
    counts: number | undefined;
    pageNo: number;
    pageSize: number;
    private addRowSubscription: Subscription;
    private removeRowSubscription: Subscription;
    private editRowSubscription: Subscription;
    // subscriptions to app-lifetime CommunicationService streams, released on destroy
    private communicationSubs = new Subscription();
    searchObject: { key: any; value: any; } | null;

    constructor(public qcs: QuestionControlService,
        public baseService: BaseService,
        public dialogService: DialogService,
        public route: ActivatedRoute,
        public cdRef: ChangeDetectorRef,
        public authenticationService: AuthenticationService,
        public appService: AppService,
        public alertService: AlertsService,
        public editableGridService: editableGridService,
        public modalService: SmartModalService,
        private utilService: UtilService,
        public asideBarService: AsideBarService,
        public rolePermissionService?: RolePermissionService,
        private printService?: PrintService,
        public communicationService?: CommunicationService,
        public loader?: LoaderService,
        public preferenceService?: PreferenceService,
        public injector?: Injector
    ) {
        this.isCims.is_cims = false;
    }
    ngOnChanges(changes) {
        console.log("changes detected", changes);
    }
    private _lastItemsLength: number = -1;
    ngDoCheck() {
        // Detect in-place array mutations (e.g. .value.push() without setValue())
        if (this.parentForm && this.id && this.parentForm.controls[this.id]) {
            const controlValue = this.parentForm.controls[this.id].value;
            if (Array.isArray(controlValue) && controlValue.length !== this._lastItemsLength) {
                this._lastItemsLength = controlValue.length;
                this.items = [...controlValue];
                this.counts = controlValue.length;
            }
        }
        if (this.dependentField != "" && this.dependentField != undefined) {
            if (this.parentForm == undefined) {
                if (this.dependentField == '')
                    this.dependentVal = this.dependentField;
                else if (this.dependentVal != this.dependentField) {
                    this.setFormFields();
                }
            } else {
                if (this.parentForm.controls[this.dependentField]) {
                    var currentDependentVal = this.parentForm.controls[this.dependentField].value;
                    if (this.dependentVal != currentDependentVal) {
                        this.dependentVal = this.parentForm.controls[this.dependentField].value;
                        if (this.populateField == undefined || this.populateField == '')
                            this.items = [];
                        this.setFormFields();
                    }
                }
            }

        }
        if (this.parentForm && this.dependentFieldMap && this.dependentFieldMap.length) {
            this.dependentFieldMap.forEach(entry => {
                const sourceField = entry.dependent_field || entry.dependentField;
                const targetField = entry.populate_field || entry.populateField;
                if (!sourceField || !targetField || !this.parentForm.controls[sourceField]) return;
                const currentVal = this.parentForm.controls[sourceField].value;
                if (this.dependentMapVals[targetField] != currentVal) {
                    this.dependentMapVals[targetField] = currentVal;
                    this.propagateDependentMapValue(targetField, currentVal);
                }
            });
        }
    }

    propagateDependentMapValue(targetField: string, value: any) {
        if (this.formBlocks && this.formBlocks.blocks) {
            this.formBlocks.blocks.forEach(block => {
                if (!block.fields) return;
                block.fields.forEach(field => {
                    if (field.name == targetField) {
                        field.default = value;
                    }
                });
            });
        }
        if (this.childQuestions && this.childQuestions[targetField]) {
            this.childQuestions[targetField].value = value;
        }
        // emitEvent false: these are hidden plumbing fields, firing their dependents would restart
        // the very cascade that is setting the parent values
        if (this.childForm && this.childForm.controls && this.childForm.controls[targetField]) {
            this.childForm.controls[targetField].setValue(value, { emitEvent: false });
        }
    }
    setFormFields() {
        this.showPage = false;
        this.fields = [];
        this.fieldGroupQues = [];
        this.fieldGroups = [];
        this.formBlocks = [];
        this.listBlocks = [];
        setTimeout(() => {
            this.cdRef.markForCheck();
            this.ngOnInit();
        });
    }
    ngOnInit(): void {
        // Nested composite array pagination is not implemented
        const parentForm = this.parentForm as any;
        if (parentForm?.parentForm) {
            this.question.pagination_enabled = false;
            console.log('Nested composite array pagination is not implemented');
        }
        if (this.isPaginationEnabled) {
            this.pageNo = 1;
            this.pageSize = 10;
            this.fetchPaginatedCompositeArray();
        }
        this.form_config = {
            "submitButton": true,
            "cancelButton": false,
            "filterForm": false,
            "clearOnSave": true,
            "delegateSave": true,
            "cancelRoute": '',
            "id": (this.id) ? this.id : this.resource,
            "parentForm": this.parentForm,
            "delta_update": this.config.delta_update != undefined ? this.config.delta_update : true,
            "compositearray_action": "ADD",//this will always be add will help us for populate,
            "remove_asidebar": true
        }

        this.gridConfig = {
            "print_allowed": false,
            "viewAll": true,
            "hideSearchBox": !this.isPaginationEnabled,
            "hideResult": true,
            "allowPagination": this.isPaginationEnabled,
            "showHeader": this.isPaginationEnabled,
            "customButtonsAllowed": this.isPaginationEnabled,
            "show_actions": true,
            "resource": "composite__" + this.resource,
            "allowConfigGrid": true,
            ...(this.config?.expandTable !== undefined && {
                expandTable: this.config.expandTable
            })
        }

        if (this.isPaginationEnabled) {
            this.gridConfig["complex_search"] = this.question.complex_search;
        }
        console.log("id: ", this.id, "pagination_enabled: ", !!this.question.pagination_enabled);
        if (this.config != undefined && this.config.parentForm != undefined) {
            this.form_config.parentForm = this.config.parentForm;
        }
        this.activatedResource = this.route.snapshot.data.decorator;
        if (this.question?.decorator && typeof this.question.decorator === 'string' && this.injector) {
            const DecoratorClass = this.appService._appData?.DECORATOR_DEF?.[this.question.decorator];
            if (DecoratorClass) {
                this.decorator = new DecoratorClass(this.route, this.question.decorator, this.injector);
            }
        }
        this.setFormBtn();
        this.baseService.getResourceDef(this.resource, (resouceDef) => {
            if (resouceDef) {
                //config check for edit and delete btn
                if (resouceDef && resouceDef.config != undefined && resouceDef.config.allowConfigGrid == false) {
                    this.gridConfig["allowConfigGrid"] = false;
                }
                if (resouceDef && resouceDef.config != undefined && resouceDef?.config?.highlight_row) {
                    this.gridConfig["class_conditions"] = resouceDef.config.class_conditions;
                }
                if (resouceDef && resouceDef.config != undefined && resouceDef?.config?.showIndex) {
                    this.gridConfig["showIndex"] = resouceDef.config.showIndex;
                }
                if (resouceDef.config != undefined && resouceDef.config.noeditGridOnModify && this.current_action == 'MODIFY') {
                    this.question.hideEdit = true
                }
                if (resouceDef.config != undefined && resouceDef.config.nodeleteGridOnModify && this.current_action == 'MODIFY') {
                    this.question.hideDelete = true
                }
                if (resouceDef?.config?.compositeGridOutsideText && resouceDef?.config?.compositeGridOutsideText?.id && resouceDef?.config?.compositeGridOutsideText?.text) {
                    this.gridConfig['compositeGridOutsideText'] = resouceDef?.config?.compositeGridOutsideText
                }
                if (this.config && this.config.composite_formType == "pushable") {
                    this.form_config['remove_asidebar'] = false;
                    if (resouceDef.form.blocks[0] && resouceDef.form.blocks[0].array_type)
                        resouceDef.form.blocks[0].array_type = 'flat';
                    if (resouceDef.form.bookmark)
                        delete resouceDef.form.bookmark;
                }
                this.showPage = true;
                this.formBlocks = resouceDef.form;
                this.setgridFilters(resouceDef);
                if (resouceDef.config != undefined && resouceDef.config.composite_form != undefined && resouceDef.config.composite_form) {
                    this.form_config['composite_form'] = true;
                }
                //check condition for disable composite-array btn
                if (this.question.btnConditions != undefined && typeof this.question.btnConditions == 'object' && this.question.btnConditions.length > 0) {
                    this.question.btnConditions.forEach(elem => {
                        if (elem.expression) {
                            let valid;
                            valid = eval(elem.expression)
                            if (valid != undefined && valid != null && valid)
                                this.form_config['btnDisabled'] = true;
                        }
                    });
                }
                if (resouceDef.list && resouceDef.list.bulkAction) { // Bulk action added in composite array
                    this._currentData.currentCompositeArrayBulkAction = {};
                    this._currentData.currentCompositeArrayBulkAction = resouceDef.list.bulkAction;
                }
                if (resouceDef.config != undefined && resouceDef.config.remove_asidebar != undefined) {
                    this.form_config['remove_asidebar'] = resouceDef.config.remove_asidebar;
                } else
                    if ((this.dependentField != "" && this.dependentField != undefined) || (this.dependentFieldMap && this.dependentFieldMap.length)) {
                        this.replaceDependentValue();
                    }
                this.formBlocks.bannerJson = this.bannerJson;
                if (this.formBlocks.blocks && this.formBlocks.blocks[0].array_type != undefined && this.formBlocks.blocks[0].array_type == 'flat') {
                    this.setArrayform();
                }
                if (this.formBlocks.blocks && this.formBlocks.blocks[0].hide_array_button != undefined && this.formBlocks.blocks[0].hide_array_button == true) {
                    this.hide_array_button = true;
                }
                if (resouceDef.list != null)
                    this.listBlocks = resouceDef.list.fields;
                if (resouceDef.customCapability) {
                    this.customCapability = resouceDef.customCapability;
                }
                if (resouceDef.custom_button != undefined && resouceDef.custom_button != null)
                    this.customButton = resouceDef.custom_button;
                this.baseService.getReferredField(resouceDef.form, (response) => {
                    this.fieldGroups = response[0];
                    this.fieldGroups.fields.sort((a, b) => { return a.order - b.order });
                    this.applyConfigFieldOverrides(resouceDef, () => this.tablefields(resouceDef));
                });
                if (this.question && this.question.update_list_outsource) {
                    this.isOutSourceModifyAllowed();
                }
            }
        });
        this.enableDisableButton();
        this.togglerFunction();
    }

    setFormBtn() {
        if (this.question != undefined && this.question.button != undefined && this.question.button) {
            this.btn = this.question.button;
        }
    }
    onBulkActionClicked(event) {
        if (event.action && event.action.action && event.action.action == "delete" && event.selectedIndices && event.selectedIndices.length) {
            for (let index in event.selectedIndices) {
                if (index && event.selectedIndices[index]) {
                    this.items[index]['checked'] = true;
                } else {
                    this.items[index]['checked'] = false;
                }
            }
            let remaingItem = this.items.filter((f) => { return !f.checked });
            if (remaingItem.length > 0) {
                for (let data of remaingItem) {
                    delete data.checked
                }
            }
            if (remaingItem.length == 0) {
                this.datagrid.isChecked = 0;
                this.datagrid.selectedCount = 0;
                this.datagrid.selectedIndices = [];
                this.datagrid.selectedItems = [];
                this.datagrid.data.resource = remaingItem;
                this.writeValue(remaingItem)
            }
            if (remaingItem.length) {
                this.datagrid.data.resource = remaingItem;
                this.writeValue(remaingItem)
            }
            this.loader.hideSpinner();
        }
    }
    /**
     * This is use for Dependent value replace in dropdown args & filter with !!!!!! value
     */

    replaceDependentValue() {
        this.formBlocks.blocks.forEach(block => {
            block.fields.forEach(field => {
                if (this.dependentFieldMap && this.dependentFieldMap.length && this.parentForm != undefined) {
                    const mapEntry = this.dependentFieldMap.find(entry => (entry.populate_field || entry.populateField) == field.name);
                    if (mapEntry) {
                        const sourceField = mapEntry.dependent_field || mapEntry.dependentField;
                        if (this.parentForm.controls[sourceField]) {
                            field.default = this.parentForm.controls[sourceField].value;
                        }
                    }
                }
                if (this.populateField != undefined || this.populateField != '') {
                    if (field.name == this.populateField) {
                        if (this.parentForm == undefined) {
                            this.dependentVal = this.dependentField;
                        } else {
                            this.dependentVal = this.parentForm.controls[this.dependentField].value;
                        }
                        field.default = this.dependentVal;
                    }
                } else if (field.component == "dropdown") {
                    if (field.dependents) {
                        field.dependents.forEach(dependent => {
                            if (dependent.args) {
                                if (this.dependentVal != "")
                                    dependent.args = dependent.args.replace("!!!" + this.dependentField + "!!!", this.dependentVal);
                            }
                        });
                    }
                    if (field.datasource) {
                        if (field.datasource.args) {
                            field.datasource.args = field.datasource.args.replace("!!!" + this.dependentField + "!!!", this.dependentVal);
                        }
                    }
                }
            });
        });
    }

    setArrayform() {
        this.popupfields = this.formBlocks;
        this.objData = { formblocks: this.formBlocks, data: null, activatedResource: this.activatedResource };
        this.activatedResource = this.activatedResource;
        this.showflatform = true;
    }

    get value() {
        return this._value;
    }

    set value(val) {
        this.items = val;
        this.propagateChange(val);
    }

    private refreshGridData(count: number = Array.isArray(this.items) ? this.items.length : 0) {
        this.items = Array.isArray(this.items) ? [...this.items] : [];
        this.counts = count;
        this._lastItemsLength = this.items.length;
        this.cdRef.markForCheck();
    }


    writeValue(value) {
        if (value || this.value) {
            if (Array.isArray(value) || Array.isArray(this.value)) {
                this.items = value || this.value;
            } else {
                this.items = [];
                if (value) {
                    this.items = [...this.items, value];
                }

                else if (this.value) { this.items = [...this.items, this.value]; }
            }

        } else {
            this.items = [];
        }
        this._lastItemsLength = Array.isArray(this.items) ? this.items.length : -1;
        this.propagateChange(this.items);
        //TODO: fire value change
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }
    registerOnTouched(fn: any): void {

    }
    setDisabledState?(isDisabled: boolean): void {
    }

    /**
     * Facility-config driven field overrides, declared in the row resource's json:
     *   "config": { "config_field_overrides": [{
     *       "module_code": "inventory-management", "config_code": "GRN_RULES-101",
     *       "option": "<multivalue id>",            // omit to apply whenever the config is active
     *       "form": { "<field name>": { ...keys merged over the popup field } },
     *       "list": { "<field name>": { ...keys merged over the grid column } } }] }
     * Runs before the grid columns are built, so a field can switch component (eg. monthYear ->
     * date) without a decorator. Overridden fields are copied, never mutated, because the
     * resource def can be the shared JSON_DEF cache. Screens without the key are untouched.
     */
    applyConfigFieldOverrides(resouceDef, done: () => void) {
        const rules = resouceDef?.config?.config_field_overrides;
        if (!Array.isArray(rules) || rules.length == 0) {
            done();
            return;
        }
        //VIEW renders the grid as soon as fields is truthy; hold it until the columns are final
        if (this.current_action == 'VIEW' || this.question?.view_mode) {
            this.fields = null;
        }
        //shared resolver: one cached GET_CONFIG per facility + config, however many grids ask
        this.utilService.resolveConfigFieldOverrides(resouceDef, (overrides) => {
            if (Object.keys(overrides.form).length && this.formBlocks?.blocks) {
                this.formBlocks = { ...this.formBlocks, blocks: this.formBlocks.blocks.map(block => Array.isArray(block.fields) ? { ...block, fields: this.utilService.mergeFieldOverrides(block.fields, overrides.form) } : block) };
                if (this.showflatform) {
                    this.setArrayform();
                }
            }
            if (Array.isArray(this.listBlocks)) {
                this.listBlocks = this.utilService.mergeFieldOverrides(this.listBlocks, overrides.list);
            }
            done();
        });
    }

    tablefields(resouceDef?) {
        this.fields = [];
        if (this.listBlocks.length == 0) {
            this.fieldGroups.fields.forEach(el => {
                if (el.component == 'composite-array' && el.type != undefined)
                    this.fields.push({ heading: el.label, name: el.name, format: el.format, type: el.type, datasource: el.datasource });
                else
                    this.fields.push({ heading: el.label, name: el.name, format: el.format, datasource: el.datasource });
                console.log("this.fieldsthis.fields", this.fields);
            });
        } else {
            this.listBlocks.forEach(el => {
                if (el.conditions != undefined && el.conditions.length > 0) {
                    this.conditionShow(el, this.current_action);
                }
                console.log("this.fieldsthis.fields", this.fields);
                this.fields.push({ heading: el.heading, name: el.name, type: el.type, format: el.format, hidden: el.invisible, config: el.config, datasource: el.datasource, resource: el.resource, map: el.map, showImage: el.showImage, document_type: el.document_type, fieldName: el.fieldName, commaDisable: el.commaDisable, linkName: el.linkName, aciton_type: el.aciton_type, action_config: el.action_config, grid_color_text: el.grid_color_text, class_conditions: el.class_conditions });

            });
        }
        if (this.current_action != 'VIEW' && this.utilService.isTalbet()) {
            this.workingFields(resouceDef);
            this.fields = this.rolePermissionService.getAllowedContextMenu(this.fields, this.getCapabilityDeskTop(), this.resource, 'button');
        }
        else if (this.current_action != 'VIEW' && this.utilService.isMobile()) {
            this.workingFields(resouceDef);
            this.fields = this.rolePermissionService.getAllowedContextMenu(this.fields, this.getCapability(), this.resource, this.question != undefined && !this.question.hideEdit ? undefined : 'button');
        }
        else {
            // this.fields = this.rolePermissionService.getAllowedContextMenu(this.fields, this.getButtons(), this.resource);
            this.workingFields(resouceDef);
            this.fields = this.rolePermissionService.getAllowedContextMenu(this.fields, this.getCapabilityDeskTop(), this.resource, 'button');

        }
        console.log("Array fields ", this.fields);
    }

    workingFields(resouceDef) {
        if (resouceDef.list && resouceDef.list.gridButtons != undefined) {
            if (this.fields.find(elem => (elem.name == 'gridButton')) == undefined) {
                resouceDef.list.gridButtons.name = "gridButton";
                this.fields.push(resouceDef.list.gridButtons);
            }
        }
    }

    getValue(item: any, field: any) {
        let fn; // Dont remove it, used for format when arrow fn is removed
        var format = field.format;
        if (field.type === 'composite') {
            try {
                if (item)
                    return eval(format)(item);
                else
                    return '';
            } catch (e) {
                ;
                return '';
            }
        } else if (field.type === 'array') {
            let val = [];
            if (item[field.name] != undefined && item[field.name].length != undefined && item[field.name].length > 0) {

                for (let i = 0; i < item[field.name].length; i++) {
                    let arrayItem = item[field.name][i];
                    let e = eval(field.format)(arrayItem);
                    if (e) {
                        val.push(e);
                    }
                }
            }
            return val;
        }
        else {
            const name = field.name;
            let value = null;
            if (item) {
                value = item[name];
            }
            if (field.type == 'boolean' && (value == undefined || value == ""))
                value = false;
            return value;
        }
    }
    showDocument(itemObj, field) {
        var item = itemObj[field.name];
        let obj = { data: { id: item }, title: 'View Document', size: DialogModalSize.Lg };
        this.dialogService.open(ShowPdfComponent, obj).afterClosed.subscribe(
            response => {

            }
        );
    }

    togglerFunction() {
        this.asideBarService.subsVar = this.asideBarService.getToggler().subscribe((val: any) => {
            if (this.question.multiselect) {
                let l: any = localStorage.getItem(this.question.multiselect);
                if (l != null) {
                    l = JSON.parse(l);
                    l['multiselect'] = val.multiselect;
                } else {
                    l = {};
                    l['multiselect'] = val.multiselect;
                }
                this.preferenceService.saveTableConfigData(this.question.multiselect, JSON.stringify(l), () => {
                    localStorage.setItem(this.question.multiselect, JSON.stringify(l));
                });
            }
            if (val && val.multiselect) {
                if (this.formBlocks && this.formBlocks.blocks && this.formBlocks.blocks[0] && this.formBlocks.blocks[0].aside_header && (this.formBlocks.blocks[0].aside_header == 'Clinical Order' || this.formBlocks.blocks[0].aside_header == 'Medication Order'))
                    this.addRow(true);
            } else if (this.formBlocks && this.formBlocks.blocks && this.formBlocks.blocks[0] && this.formBlocks.blocks[0].aside_header && (this.formBlocks.blocks[0].aside_header == 'Clinical Order' || this.formBlocks.blocks[0].aside_header == 'Medication Order')) {
                this.addRow(false);
            }
        });
    }


    addRow(multiselect?) {
        let flag = true;
        if (this.question && this.question.multiselect && multiselect == undefined) {
            let l: any = localStorage.getItem(this.question.multiselect);
            if (l != null) {
                l = JSON.parse(l);
                if (l.multiselect == undefined) {
                    multiselect = true;
                } else {
                    multiselect = l.multiselect;
                }
            } else {
                multiselect = true;
            }
        }
        if (multiselect != undefined && multiselect) {
            if (this.decorator && this.decorator.manipulateCompositeArrayRow != undefined) {
                this.decorator.manipulateCompositeArrayRow((res) => {
                    flag = res;
                });
            }
        }
        if (this.question.config_add && this.decorator && this.decorator.manipulateCompositeRowConfig != undefined) {
            flag = false;
            this.decorator.manipulateCompositeRowConfig(this.question.config_add, (res) => {
                flag = res;
                this.setAsideView(flag, multiselect);
            });
        } else {
            this.setAsideView(flag, multiselect);
        }
    }

    setAsideView(flag, multiselect) {
        if (flag) {
            var newobj = { data: { formblocks: this.formBlocks, data: null, activatedResource: this.activatedResource, action: "ADD", compositearray_action: "ADD" } };
            if (this.config != undefined && this.config.parentForm != undefined) {
                newobj.data["parentForm"] = this.config.parentForm;
            }
            if (this.decorator != undefined && this.decorator != false) {
                newobj.data["decorator"] = this.decorator;
            }
            if (this.bannerJson != undefined)
                newobj.data["banner"] = this.bannerJson;
            if (this.customButton != undefined)
                newobj.data["customButton"] = this.customButton;
            newobj.data['resource'] = this.resource;
            if (this.formBlocks.blocks[0].array_type != undefined && this.formBlocks.blocks[0].array_type === 'aside') {
                newobj.data["formType"] = "aside";
                newobj.data["barcode"] = this.config != undefined && this.config.barcode != undefined ? this.config.barcode : false;
                let componentConfig = {
                    inputs: {
                        data: newobj.data
                    },
                    container: true
                };
                if (this.question.multiselect && multiselect != undefined && !multiselect) {
                    if (this.formBlocks.blocks[0].aside_header === 'Medication Order' && this?.decorator?.showMultiselect === false) {
                        // Do not show the multiselect toggle
                    } else {
                        let toggleButton = {
                            "label": "Multiselect",
                            "multiselect": false
                        }
                        componentConfig.inputs['toggleButton'] = toggleButton;
                    }
                }
                var size = this.fieldGroups && this.fieldGroups.size ? this.fieldGroups.size : 'lg';
                this.asideBarService.appendComponentTo('aside-modal-container', CompositeArrayObjectComponent, componentConfig, size, this.formBlocks.blocks[0].aside_header).subscribe(data => {

                    if (data != undefined) {
                        this.setDataFromForm(data.data);
                        this.valueAdded.emit({ type: true, items: this.items, action: 'ADD' });
                        this.communicationSubs.add(this.communicationService.itemInvalidEmitted$.subscribe(data => {
                            this.removeRow(data)
                        }))
                    }
                    if (data.data && data.data.currentBtnVal && data.data.currentBtnVal.action == 'add_another') {
                        setTimeout(() => {
                            this.addRow(false)
                        })
                    }
                })
                this.asideBarService.getCompositeForm().subscribe(res => {
                    res.obj.id = this.id;
                    this.getDataFn(res)
                })
            } else {
                this.dialogService.open(CompositeArrayObjectComponent, newobj).afterClosed.subscribe(
                    response => {
                        // let result = response;
                        this.setDataFromForm(response);
                        this.enableDisableButton();
                    });
                return false;
            }
        }
    }

    setDataFromForm(response) {
        if (response != null) {
            if (this.replace_items == undefined || this.replace_items == "") { // Current feature will be running as it
                this.pushItem(response.result);
                //this.items.push(response.result);
            } else {
                try {
                    if (response.result[this.replace_items] != "") {
                        let itemArray: any[] = JSON.parse(response.result[this.replace_items]);
                        if (itemArray.length > 0) {
                            itemArray.forEach(item => {
                                this.pushItem(item);
                            });
                        }
                    } else {
                        this.pushItem(response.result);
                    }
                } catch (e) {
                    console.error("Error in add extra items");
                }
            }
            this.value = [...this.items];
        }
    }


    evalExpression(expression, item, items) {
        try {
            if (eval(expression)) {
                this.items = [...this.items, item];
            }
            else {
                this.error_message = this.question.error_message != undefined && this.question.error_message ? this.question.error_message : this.error_message;
                this.alertService.error(this.error_message);
            }
        } catch (error) {
            console.error("Expression Invalid")
        }
    }

    pushItem(item: any, obj?) { // This function check the array with duplicate code.
        let num: any = "";
        for (let key in item) {
            if (item.hasOwnProperty(key)) {
                if (!item[key]) {
                    num = 1;
                }
                else {
                    num = 0;
                    break;
                }
            }
        }
        if (num == 1) {
            this.alertService.error('f.l.entalwd');
            return;
        }
        else if (num == 0 || num == undefined || num == "") {
            if (this.question.expression != undefined && this.question.expression) {
                this.evalExpression(this.question.expression, item, this.items);
            }
            else if (this.item_key == undefined || this.item_key == "") {
                if (this.question != undefined && this.question.persist_position != undefined && this.question.persist_position && obj != undefined && obj.index != undefined) {
                    const updatedItems = [...this.items];
                    updatedItems[obj.index] = item;
                    this.items = updatedItems;
                }
                else {
                    if (this.question != undefined && this.question.persist_position != undefined && this.question.persist_position && this.question.showLastAddedAtTop != undefined && this.question.showLastAddedAtTop) {
                        if (this.items.length == 0) {
                            this.items = [...this.items, item];
                        }
                        else {
                            this.items = [item].concat(this.items);
                        }
                    }
                    else {
                        this.items = [...this.items, item];
                    }
                }

            } else {
                this.error_message = this.question.error_message != undefined && this.question.error_message ? this.question.error_message : this.error_message;
                const pos = this.items.findIndex(i => this.isSameItem(i, item));
                if (pos === -1) {
                    this.items = [item].concat(this.items);
                } else {
                    this.alertService.error(this.error_message);
                }
            }
        }

    }

    private isSameItem(i1: any, i2: any): boolean {
        const keys = this.item_key.split(',');
        let key: boolean = false;;
        for (const k of keys) {
            key = this.getNestedValue(i1, k) === this.getNestedValue(i2, k);
            if (key) {
                return key;
            }
        }
        return key;
    }

    getConfigValues(event) {
        if (event.filterPrintInfo != undefined && event.filterPrintInfo) {
            this._currentData.filterPrintInfo = event.filterPrintInfo;
            this._currentData.saveFilterKey = true;
        } else if (event.configureGrid != undefined) {
            this.configUIEngine(event.configureGrid);
        }
    }
    configUIEngine(config) {
        var obj: any = {};
        obj = { ...obj, ...config };
        obj["key"] = this.getConfigurationKey(config);
        obj["resource_name"] = this.datagrid._currentResource;
        if (config.context == 'grid') {
            obj["resource_name"] = this.resource;
        }
        this.preferenceService.openConfigurePopup(obj, (response) => {
            if (response.result != undefined) {
                this.preferenceService.saveConfigurationData(obj, response.result, (result) => {
                    console.log(result);
                });
            }
        });
    }

    getConfigurationKey(config) {
        var resourceName = this.datagrid._currentResource;
        if (config.context == 'grid') {
            resourceName = this.resource;
        }
        return this.preferenceService.getConfigurationKey(resourceName);
    }

    private getNestedValue(obj: any, key: string): any {
        // const keys = key.split(',');
        // for (const k of keys) {
        //     if(obj[k] != undefined)
        //         obj = obj[k];
        // }
        if (obj[key])
            obj = obj[key];
        return obj;
    }
    addRows(event) {
        if (this.replace_items != "" && event.result[this.replace_items]) {
            if (this.replace_items == undefined || this.replace_items == "") { // Current feature will be running as it
                this.pushItem(event.result[this.replace_items]);
                //this.items.push(response.result);
            } else {
                try {
                    if (event.result[this.replace_items] != "") {
                        //let itemArray: any[] = JSON.parse(event.result[this.replace_items]);
                        if (event.result[this.replace_items].length > 0) {
                            event.result[this.replace_items].forEach(item => {
                                this.pushItem(item);
                            });
                        }
                    }
                } catch (e) {
                    console.error("Error in add extra items");
                }
            }
            this.value = this.items;
        } else {
            console.log(event, 'event');
            if (this.setUpdate || this.setUpdate === 0) {
                this.items.splice(this.setUpdate, 1);
                //let result = response.result;
                //this.items.push(event.result);
                this.pushItem(event.result);
                this.value = this.items;
                this.enableDisableButton();
            }
            else {
                this.pushItem(event.result);
                //this.items.push(event.result);
                this.value = this.items;
            }
        }
        if (this.isPaginationEnabled) {
            this.addRowSubscription = this.postAction(event.result, 'ADD_COMPOSITE_ARRAY_ROW', this.appService.getApplication(), localStorage.getItem('currentResource')).subscribe(res => {
                if (res.errCode != undefined && res.errCode == 0 && res.resource && res.resource.length > 0) {
                    // Success handling
                    this.alertService.success(res.message || 'Composite array updated successfully');
                    // Calculate and navigate to the last page after adding new item
                    const newTotalCount = (this.counts || 0) + 1;
                    const lastPage = Math.ceil(newTotalCount / this.pageSize);
                    this.pageNo = lastPage;
                    // Optionally refresh data or update UI
                    // this.value = this.items = res.resource[0][this.id];
                } else {
                    // Error handling
                    this.alertService.error(res.message || 'Failed to update composite array');
                }
                this.fetchPaginatedCompositeArray();
                // this.valueAdded.emit({ type: true, items: this.items, action: 'ADD' });
            });
        } else {
            this.valueAdded.emit({ type: true, items: this.items, action: 'ADD' });
        }
        this.items = [...this.items];
        this.value = this.items;
        this.setUpdate = false;
    }

    editRow(index: number) {
        event.preventDefault();
        this.showflatform = false;
        let dataVal = this.items[index];
        let newobj = { data: { formblocks: this.formBlocks, data: dataVal, activatedResource: this.activatedResource, action: "MODIFY", decorator: this.decorator } };
        if (this.config != undefined && this.config.parentForm != undefined) {
            newobj.data["parentForm"] = this.config.parentForm;
        }
        if (this.formBlocks.blocks[0].array_type != undefined && this.formBlocks.blocks[0].array_type === 'aside') {
            newobj.data["formType"] = "aside";
            let componentConfig = {
                inputs: {
                    data: newobj.data
                }
            };
            var size = this.fieldGroups != undefined && this.fieldGroups.size != undefined ? this.fieldGroups.size : 'lg';
            this.asideBarService.appendComponentTo('aside-modal-container', CompositeArrayObjectComponent, componentConfig, size, this.formBlocks.blocks[0].aside_header).subscribe(data => {
                if (data != undefined) { this.editRowAside(data.data, index); }
            })
        }
        else {
            this.dialogService.open(CompositeArrayObjectComponent, newobj).afterClosed.subscribe(
                response => {
                    this.editRowAside(response, index);
                });
        }
        if (this.formBlocks.blocks[0].array_type != undefined && this.formBlocks.blocks[0].array_type === 'flat') {
            this.showflatform = true;
        }
        return false;
    }
    removeAllItems() {
        this.items = [];
    }
    removeRow(index: number) {
        event.preventDefault();
        let a = this.items.slice(0)
        let deletedRow = this.items.splice(index, 1);
        this.refreshGridData(this.isPaginationEnabled && this.counts ? this.counts - 1 : this.items.length);
        if (this.isPaginationEnabled) {
            this.removeRowSubscription = this.postAction(deletedRow[0], 'DELETE_COMPOSITE_ARRAY_ROW', this.appService.getApplication(), localStorage.getItem('currentResource')).subscribe(res => {
                if (res.errCode != undefined && res.errCode == 0 && res.resource && res.resource.length > 0) {
                    // Success handling
                    this.alertService.success(res.message || 'Composite array updated successfully');
                    // Optionally refresh data or update UI
                    // this.items = res.resource[0][this.id];
                    // this.onRemoveItem.emit({ index: index, items: this.items, itemss: a });
                    // if (this.items.length == 0)
                    //     this.valueAdded.emit({ type: false, items: this.items, index: index, action: 'delete', itemss: a, deletedRow: deletedRow });
                    // else
                    //     this.valueAdded.emit({ type: true, items: this.items, index: index, action: 'delete', itemss: a, deletedRow: deletedRow });
                } else {
                    // Error handling
                    this.alertService.error(res.message || 'Failed to update composite array');
                }
                this.fetchPaginatedCompositeArray();
            });
        } else {
            // if (this.items.length == 0) {
            //     this.valueAdded.emit({type: true, items: this.items});
            // }
            this.onRemoveItem.emit({ index: index, items: this.items, itemss: a });
            if (this.items.length == 0)
                this.valueAdded.emit({ type: false, items: this.items, index: index, action: 'delete', itemss: a, deletedRow: deletedRow });
            else
                this.valueAdded.emit({ type: true, items: this.items, index: index, action: 'delete', itemss: a, deletedRow: deletedRow });
            this.enableDisableButton();
            this.propagateChange(this.items);
        }
        return false;
    }

    enableDisableButton() {
        if (this.items != null) {
            if (this.items.length == this.arrayLimit)
                this.btnDisabled = true;
            else this.btnDisabled = false;
        }
    }
    conditionShow(field, current_action?) {
        if (field.conditions != undefined && field.conditions.length > 0) {
            var currentUserType = this.authenticationService.getUserType();
            var currentApplication = this.appService.getApplication();
            var invisibleDone = false;
            for (let i = 0; i < field.conditions.length; i++) {
                let currentConditions = field.conditions[i];
                /**** FOR APPLICATION ****/
                if (currentConditions.application != undefined) {
                    if (currentConditions.application.indexOf(currentApplication) > -1) {
                        if (currentConditions.action == 'invisible') {
                            field.invisible = true;
                            invisibleDone = true;
                        }

                        if (currentConditions.action == 'visible') {
                            field.invisible = false;
                            invisibleDone = false;
                        }
                    } else {
                        if (currentConditions.action == 'visible') {
                            field.invisible = true;
                            invisibleDone = true;
                        }
                    }
                }

                /**** FOR USER TYPE ****/
                if (currentConditions.user_type != undefined) {
                    if (currentConditions.user_type.indexOf(currentUserType) > -1) {
                        if (!invisibleDone) {
                            if (currentConditions.action == 'invisible') {
                                field.invisible = true;
                                invisibleDone = true;
                            }
                        }
                    }
                }
                /**** FOR USER TYPE ****/

                /**** FOR ACTIONS ****/
                if (currentConditions.resource_action != undefined) {
                    if (currentConditions.resource_action.indexOf(current_action) > -1) {
                        if (!invisibleDone) {
                            if (currentConditions.action == 'invisible') {
                                field.invisible = true;
                                invisibleDone = true;
                            }
                        }
                    }
                }
                /**** FOR USER TYPE ****/

            }
        }
    }

    getDataFn(data: any) {
        if (data.type == "form" || data.type == "mapping") {
            // kept so dependentFieldMap can reach the live row instead of rebuilding it
            if (data.type == "form") {
                this.childForm = data.obj;
            } else {
                this.childQuestions = data.obj;
            }
            this.getData.emit({ type: data.type, obj: { id: this.id, form: data.obj } });
        }
    }
    /**********************Link inside grid **********************************/
    openPopUp(field: any, item: any) {
        this.view_details(this.listBlocks.find(x => x.name == field.name), item);
    }
    view_details(field, item) {
        if (this.config && this.config.parentForm && this.config.parentForm.value) {
            var pageItem = { ...item, ...this.config.parentForm.value }
        } else {
            var pageItem = item;
        }
        if (field.aciton_type === "popup") {
            let data_config = {
                resourcedef: { ...field.action_config.datasource, ...field.action_config },
                currentData: pageItem,
                type: field.action_config.type
            };
            this.modalService.open(PopUpOverGridWithControlsComponent, data_config, field.action_config.header, this.editableGridService.checkingModalSize(field.action_config.size ? field.action_config.size : 'sm')).subscribe(
                response => {
                    console.log("model closed");
                }, err => {

                }
            );
        }
    }

    editRowAside(response, index) {
        if (response != null) {
            if (this.storeItems && response.result != undefined) {
                this.storeItems[index] = response.result;
            }
            let removedItem = [];
            if (this.question.persist_position != undefined && this.question.persist_position) {

                removedItem = this.items[index];
            }
            else {
                removedItem = this.items.splice(index, 1);
            }

            //let result = response.result;
            if (this.replace_items == undefined || this.replace_items == "") {
                this.pushItem(response.result, { index: index });
            } else {
                try {
                    if (response.result[this.replace_items] && response.result[this.replace_items] != "") {
                        let itemArray: any[] = JSON.parse(response.result[this.replace_items]);
                        if (itemArray.length > 0) {
                            itemArray.forEach(item => {
                                this.pushItem(item, { index: index });
                            });
                        }
                    } else {
                        this.pushItem(response.result, { index: index });
                    }
                } catch (e) {
                    console.error("Error in add extra items");
                }
            }
            // this.items.push(response.result);
            if (this.isPaginationEnabled) {
                this.editRowSubscription = this.postAction(response.result, 'UPDATE_COMPOSITE_ARRAY_ROW', this.appService.getApplication(), localStorage.getItem('CurrentResource')).subscribe(res => {
                    if (res.errCode != undefined && res.errCode == 0 && res.resource && res.resource.length > 0) {
                        // Success handling
                        this.alertService.success(res.message || 'Composite array updated successfully');
                        // Optionally refresh data or update UI
                        // this.items = res.resource[0][this.id];
                        // this.enableDisableButton();
                        // this.valueAdded.emit({ type: true, items: this.items, action: 'edit', index: index, removedItem: removedItem[0] });
                    } else {
                        // Error handling
                        this.alertService.error(res.message || 'Failed to update composite array');
                    }
                    this.fetchPaginatedCompositeArray();
                });
            } else {
                this.value = this.items;
                this.enableDisableButton();
                this.valueAdded.emit({ type: true, items: this.items, action: 'edit', index: index, removedItem: removedItem[0] });
            }
        }
    }

    getCapabilityDeskTop() {
        if (this.current_action != 'VIEW' && !this.question.view_mode) {
            let arr = [];
            if (this.customCapability.length > 0) {
                arr = [...arr, ...this.customCapability];
            }
            if (!this.question.hideDelete && this.form_config['btnDisabled'] == undefined) {
                arr.push({ "action": "delete", "permission_required": false, show_actions: true, icon: 'fa fa-trash', "conditions": this.question.hide_delete_conditions });
            }
            if (!this.question.hideEdit && this.form_config['btnDisabled'] == undefined) {
                arr.push({ "action": "modify", "permission_required": false, show_actions: true, icon: 'fa fa-pencil', "conditions": this.question.hide_edit_conditions });
            }
            if (this.question.compositePopup) {
                arr.push({ "action": "info", icon: "fa fa-info", "permission_required": false, show_actions: true });
            }
            if (this.utilService.findCIMSenabledResourceWise(this.resource)) {
                arr.push({ "action": "info_mono", icon: "fa fa-info-circle", "permission_required": false, show_actions: true });
            }

            return arr;
        }
    }

    getCapability(val?) {
        let val_ = val != undefined ? val : true;
        let arr = [];
        if (this.customCapability.length > 0) {
            arr = [...arr, ...this.customCapability];
        }
        if (!this.question.hideDelete) {
            arr.push({ "action": "delete", "label": "Delete", "permission_required": false, show_actions: val_, "conditions": this.question.hide_delete_conditions });
        }
        if (!this.question.hideEdit) {
            arr.push({ "action": "modify", "label": "Edit", "permission_required": false, show_actions: val_, "conditions": this.question.hide_edit_conditions });
        }
        if (this.question.compositePopup) {
            arr.push({ "action": "info", "label": "Info", "permission_required": false, show_actions: val_ });
        }
        if (this.utilService.findCIMSenabledResourceWise(this.resource)) {
            arr.push({ "action": "info_mono", icon: "fa fa-info-circle", "permission_required": false, show_actions: true });
        }
        return arr;
    }


    itemClick(event) {
        console.log('itemdata is ', event)
        if (event.actionType.action == 'modify')
            this.editRow(event.index)
        if (event.actionType.action == 'delete')
            this.removeRow(event.index)
        if (event.actionType.action == 'copy')
            this.copyRow(event.data, event.index)
        if (event.actionType.action == 'add_below')
            this.addRowBelow(event.index, event.actionType)
        if (event.actionType.action == 'info')
            this.infoClicked(event.data, event.index)
        if (event.actionType.action == 'info_mono')
            this.getMonoGraphClicked(event.data, event.index)
    }
    getMonoGraphClicked(data, index) {
        const abc = this.question.required
        this.question.required = false
        this.valueAdded.emit({ items: this.items, index: index, action: 'info_mono' });
        this.question.required = abc
    }
    infoClicked(data, index) {
        const abc = this.question.required
        this.question.required = false
        this.valueAdded.emit({ items: this.items, index: index, action: 'info' });
        this.question.required = abc
    }

    copyRow(item, index) {
        if (Object.keys(item).length > 0 && index >= 0) {
            let current_item = JSON.parse(JSON.stringify(item));
            if (current_item && current_item.id) {
                delete current_item.id;
            }
            this.items.splice(index + 1, 0, current_item);
            this.propagateChange(this.items);
        }
    }
    /**
     * Opens the row form pre-filled from an existing row and inserts what the user
     * saves directly below that row. Wired from a customCapability entry, eg:
     * { "action": "add_below", "icon": "fa fa-plus", "row_config": {
     *     "reset_values": ["id"], "set_values": {"freeData": true, "freeMrp": "!!!mrp!!!"},
     *     "disable_fields": ["freeData"] } }
     */
    addRowBelow(index: number, capability?) {
        //double-click guard: the decorator's confirm is async, and DialogService keeps a single
        //dialogComponentRef, so a second open before the first closes corrupts its bookkeeping
        if (this.addRowBelowBusy)
            return false;
        if (index == undefined || index < 0 || this.items[index] == undefined)
            return false;
        let rowConfig = capability != undefined && capability.row_config != undefined ? capability.row_config : {};
        this.addRowBelowBusy = true;
        //let the decorator vet the add first (eg. confirm a duplicate) — it owns the question,
        //this only waits for its verdict
        if (this.decorator && this.decorator.confirmAddRowBelow != undefined) {
            this.decorator.confirmAddRowBelow(this.items[index], this.items, (allowed) => {
                if (allowed)
                    this.openRowBelowForm(index, rowConfig);
                else
                    this.addRowBelowBusy = false;
            });
        } else {
            this.openRowBelowForm(index, rowConfig);
        }
        return false;
    }

    private openRowBelowForm(index: number, rowConfig) {
        let newobj = {
            data: {
                formblocks: this.overrideFormBlocks(rowConfig.disable_fields),
                data: this.buildSeedRow(this.items[index], rowConfig),
                activatedResource: this.activatedResource,
                action: "ADD",
                compositearray_action: "ADD",
                resource: this.resource
            }
        };
        if (this.config != undefined && this.config.parentForm != undefined) {
            newobj.data["parentForm"] = this.config.parentForm;
        }
        if (this.decorator != undefined && this.decorator != false) {
            newobj.data["decorator"] = this.decorator;
        }
        if (this.bannerJson != undefined)
            newobj.data["banner"] = this.bannerJson;
        if (this.customButton != undefined)
            newobj.data["customButton"] = this.customButton;
        this.dialogService.open(CompositeArrayObjectComponent, newobj).afterClosed.subscribe(
            response => {
                this.addRowBelowBusy = false;
                if (response != null && response.result != undefined) {
                    //the saved row never goes through pushItem, so give the decorator the same
                    //veto the normal add path already gets (eg. duplicate-row rules)
                    if (this.decorator && this.decorator.validateRowBelow != undefined
                        && !this.decorator.validateRowBelow(response.result, this.items)) {
                        return;
                    }
                    this.items.splice(index + 1, 0, response.result);
                    this.value = [...this.items];
                    this.enableDisableButton();
                }
            });
    }

    // Clone of the clicked row carrying the capability's reset_values / set_values.
    // A set_value of "!!!key!!!" copies items[key] as-is so numbers stay numbers.
    private buildSeedRow(sourceItem, rowConfig) {
        let newItem = JSON.parse(JSON.stringify(sourceItem));
        if (Array.isArray(rowConfig.reset_values)) {
            for (let key of rowConfig.reset_values) {
                delete newItem[key];
            }
        }
        if (rowConfig.set_values != undefined) {
            for (let key of Object.keys(rowConfig.set_values)) {
                let val = rowConfig.set_values[key];
                let token = typeof val === 'string' ? val.match(/^!!!(.*?)!!!$/) : null;
                newItem[key] = token ? sourceItem[token[1]] : val;
            }
        }
        return newItem;
    }

    // formBlocks is the shared, cached resource definition, so copy the nodes on the
    // path to each disabled field and leave every other field by reference.
    private overrideFormBlocks(disableFields) {
        if (!Array.isArray(disableFields) || disableFields.length == 0)
            return this.formBlocks;
        let formblocks = { ...this.formBlocks };
        formblocks.blocks = (this.formBlocks.blocks || []).map(block => {
            if (!Array.isArray(block.fields))
                return block;
            return {
                ...block,
                fields: block.fields.map(field => disableFields.indexOf(field.name) > -1 ? { ...field, disabled: true } : field)
            };
        });
        return formblocks;
    }

    checkExpression(capability, item) {
        try {
            if (capability.expression != undefined) {
                if (eval(capability.expression)) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        } catch (Error) {
            console.log("Error is ", Error);
            return false;
        }
    }
    clickCapability(capability, item, index) {
        switch (capability.action) {
            case 'download':
                if (capability.file_data) {
                    let args = this.baseService.buildDyanamicStr(capability.file_data.args, { data: item });
                    let imageurl = capability.file_data.application + '/api/v1/' + capability.file_data.resource + '?args=' + args + '&application=' + capability.file_data.application;
                    this.baseService.getFileByUrl(imageurl, false).subscribe(res => {
                        if (res)
                            this.printService.handleFileReponse({ contentType: capability.file_data.file_type, key: capability.file_data.key }, 'download', res);
                    })
                }
                break;
            case 'copy':
                if (Object.keys(item).length > 0 && index >= 0) {
                    let current_item = JSON.parse(JSON.stringify(item))
                    this.items.splice(index + 1, 0, current_item);
                    this.propagateChange(this.items);
                }
                break;
        }
    }
    ngOnDestroy() {
        // Unsubscribe from postAction subscriptions
        if (this.addRowSubscription) {
            this.addRowSubscription.unsubscribe();
        }
        if (this.removeRowSubscription) {
            this.removeRowSubscription.unsubscribe();
        }
        if (this.editRowSubscription) {
            this.editRowSubscription.unsubscribe();
        }
        this.communicationSubs.unsubscribe();

        if (this.form_config && this.form_config.remove_asidebar)
            this.asideBarService.removeComponent();
    }
    ///////*****************************Start CIMS *************************** */
    getMonoGraph(index: number) {
        let currentItem = this.items[index];
        // let args = `drugName:DOLO TAB 650mg`;
        let args = `drugName:${currentItem.displayName}`;
        this.loader.showSpinner();
        this.baseService
            .get("GET_DRUG_MONOGRAPH_FROM_INTEGRATION", args, "stock", "inventory-management")
            .subscribe((res) => {
                if (res && res.errCode == 0 && res.resource.length > 0) {
                    let data = res.resource[0];
                    console.log("Res is", res);
                    if (data.itemName) {
                        this.showMonoGraph(data.itemName, 'Mono Graph');
                    } else {
                        this.showMonoGraph('', '');
                    }
                    this.loader.hideSpinner();
                }
            }, (err => {
                this.loader.hideSpinner();
            }));
    }
    showMonoGraph(res, title) {
        var data = {
            type: "htmlViewer",
            html: res
        };
        this.modalService.open(PopUpOverGridWithControlsComponent, data, title, 'md').subscribe(
            response => {
                console.log("model closed");
            }, err => {

            }
        );
    }
    ///****************************************End CIMS****************************** */
    ngAfterViewInit() {
        this.communicationService.appendHtmlToCompositeArray(this.appendHtml);
        this.communicationSubs.add(this.communicationService.isCims.pipe(distinctUntilChanged((prev, curr) => prev === curr)).subscribe((cims: any) => {
            if (cims) {
                console.log("is CIMS ENABLED", cims);
                this.isCims.is_cims = cims
            } else if (!cims) {
                console.log("is CIMS DISABLED", cims);
                this.isCims.is_cims = false;
            }
        }))
    }

    setgridFilters(resouceDef) {
        if (this.question.filters != undefined && this.question.filters) {
            this._currentData.currentFilterListFormFields = {};
            this._currentData.currentFilterListFormFields.blocks = resouceDef;
            if (resouceDef.list.filter != undefined && resouceDef.list.filter.quick_filters != undefined)
                this._currentData.currentFilterListFormFields.quick_filters = resouceDef.list.filter.quick_filters;
            if (resouceDef.list.dynamic_filter != undefined)
                this._currentData.currentFilterListFormFields.dynamic_filter = resouceDef.list.dynamic_filter;
        }
    }

    filterData(event) {
        try {
            if (this.storeItems)
                this.items = this.storeItems;

            // let cloneItems = JSON.parse(JSON.stringify(this.items));
            this.storeItems = this.items;

            if (this.items != undefined && this.items.length > 0) {
                let filtVal = event.split(",");
                for (let item of filtVal) {
                    let keyval = item.split(":");
                    let exp = '';
                    //case for multiselect
                    if (keyval[1].includes("#")) {
                        for (let [index, item] of keyval[1].split('#').entries()) {
                            let orStr = index < keyval[1].split('#').length - 1 ? '||' : '';
                            exp = exp + "x[keyval[0]]=='" + item + "'" + orStr;
                        }
                    }
                    else {
                        exp = "x[keyval[0]] == keyval[1]"
                    }

                    this.items = this.items.filter(x => eval(exp));
                }
            }
            // this.items = cloneItems;

        } catch (error) { }
    }
    isOutSourceModifyAllowed() {
        if (!this.isSubscriptionDoneForModify) {
            this.isSubscriptionDoneForModify = true;
            this.communicationSubs.add(this.communicationService.update_list_ca$.subscribe(data => {
                console.log("composite array items are", this.items);
                this.items = [];
                if (data && data.length > 0) {
                    this.items = JSON.parse(JSON.stringify(data));
                    this.parentForm.updateValueAndValidity();
                }
            }))
        }
    }

    onLimitChange(limitEvent) {
        if (limitEvent) {
            this.pageSize = limitEvent.target.value;
            this.pageNo = 1;
            this.onPageChange(this.pageNo);
        }
    }

    onPageChange(event) {
        this.pageNo = event;
        this.fetchPaginatedCompositeArray();
    }

    fetchPaginatedCompositeArray(resetPage: boolean = false) {
        const application = this.appService.getApplication();
        const datasource = {
            query_id: "GET_COMPOSITE_ARRAY_PAGE",
            // need to find the robust approach to get the currentResource.
            resource: localStorage.getItem('CurrentResource'),
            args: `field:${this.id},id:${this.route.snapshot?.queryParams?.key}`,
            page_size: this.pageSize,
            page_no: this.pageNo
        }

        if (this.searchObject) {
            datasource['args'] += `,search_key:${this.searchObject.key},search_value:${this.searchObject.value}`;
            if (resetPage)
                datasource['page_no'] = 1; // Reset to first page on new search
        }
        this.baseService.getData(datasource, undefined, datasource.resource, application, datasource.query_id).pipe(
            tap(() => this.loader.showSpinner()), // Initialize - show spinner at start
            finalize(() => this.loader.hideSpinner()) // Cleanup - hide spinner at end
        ).subscribe((res: any) => {
            console.log("GET_COMPOSITE_ARRAY_PAGE res", res);
            if (res && res.resource && res.resource.length > 0)
                this.items = res.resource[0][this.id];
            this.counts = res.count;
            // this.refreshGridData(res.count);
        },
            (err) => {
                console.error("Error fetching paginated composite array data", err);
            });
    }

    isPaginationEnabledAction(): boolean {
        return this.current_action === 'MODIFY' || this.current_action === 'VIEW';
    }

    postAction(payload, action, application, currentResource): Observable<any> {
        const parentForm = this.utilService.unflatten(this.parentForm.getRawValue());

        Object.keys(this.parentForm.controls).forEach(controlName => {
            if ((this.parentForm.controls[controlName] as any).question_component.question.pagination_enabled)
                delete parentForm[controlName];
        });

        parentForm[this.id] = [payload];
        if (parentForm.hasOwnProperty('extra_data')) {
            parentForm['extra_data']['_paginatedData'] = {
                field: this.id
            };
        } else {
            parentForm['extra_data'] = {
                _paginatedData: {
                    field: this.id
                }
            };
        }
        return this.baseService.action(parentForm, action, application, currentResource).pipe(
            tap(() => this.loader.showSpinner()),
            finalize(() => this.loader.hideSpinner())
        );
    }

    filterChange(event) {
        this.searchObject = null;
        if (event.key && event.value) {
            this.searchObject = { key: event.key, value: event.value };
        }
        this.fetchPaginatedCompositeArray(true);
    }

    get isPaginationEnabled(): boolean {
        return !!this.question.pagination_enabled && this.isPaginationEnabledAction();
    }

    get isItemSizeZero(): boolean {
        if (this.items == null) {
            return true;
        }
        return this.isPaginationEnabled && this.searchObject ? false : this.items.length === 0;
    }
}